import { transformSearchParamsToFilter } from '../../utils/transformSearchParamsToFilter';
import { transformSearchParamsToSort } from '../../utils/transformSearchParamsToSort';

/**
 * @param {Object} arg
 * @param {Object} [arg.filter]
 *
 * @return {Object|null}
 * */
export const getFilterData = ({ filter, sort, sortKeys }) => ({
  filter: (filter && transformSearchParamsToFilter(filter)) || null,
  sort: (sort && transformSearchParamsToSort(sort, sortKeys)) || null,
});
